<template>
  <div class="form-container">
    <MaterialInput
      v-model="metadata.title"
      v-bind="metadata.title"
      :label="'Title'"
      :disabled="true"
    />
    <MaterialInput
      v-model="metadata.shortDescription"
      v-bind="metadata.shortDescription"
      :label="'Short Description'"
      :disabled="true"
    />
    <MaterialTextArea
      v-model="metadata.longDescription"
      v-bind="metadata.longDescription"
      :label="'Long Description'"
      :disabled="true"
    />
  </div>
</template>

<script>
import MaterialInput from '../../inputs/MaterialInput.vue';
import MaterialTextArea from '../../inputs/MaterialTextArea.vue';

export default {
  name: 'CollectionGeneralEngForm',
  components: {
    MaterialInput,
    MaterialTextArea,
  },
  props: {
    metadata: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped lang="scss">
.form-container {
  padding: 32px 70px 20px 0;
}

.poster-title {
  color: #fff;
  font-weight: normal;
  margin-bottom: 10px;
}

.img-block {
  margin-bottom: 20px;
}

.poster-2x3-image{
  height: 400px;
}
</style>
